var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.334,
    height: 21,
    viewBox: "0 0 13.334 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dollar_1_",
    "data-name": "dollar (1)",
    d: "M22.365,19.665c0-2.143-1.957-4-4.985-4.736l-.743-.191V8.883c1.786.221,3.179,1.044,3.327,2.059a.955.955,0,1,0,1.889-.276c-.286-1.993-2.386-3.436-5.216-3.7V5.955a.955.955,0,0,0-1.909,0v1.01c-3.009.32-5.25,2.122-5.25,4.371,0,2.133,1.814,3.99,4.61,4.731l.64.161v5.908c-2.214-.216-3.646-1.16-3.8-2.079a.955.955,0,0,0-1.882.319c.339,1.986,2.62,3.424,5.684,3.673v1a.955.955,0,1,0,1.909,0v-1c3.277-.3,5.727-2.111,5.727-4.378Zm-7.788-5.441c-1.909-.5-3.189-1.664-3.189-2.885,0-1.173,1.455-2.183,3.341-2.446v5.366Zm2.061,7.9V16.71l.294.074c2.108.511,3.524,1.669,3.524,2.88C20.456,20.715,18.929,21.868,16.638,22.126Z",
    transform: "translate(-9.031 -5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarColored);
export default __webpack_public_path__ + "static/media/dollar-colored.4d67ca0a9ca1aa3b3e7159632824acf6.svg";
export { ForwardRef as ReactComponent };